<!-- Displaying Reward points transaction in Transction page -->

<app-customer-profile-grid
  [dataSource]="rewardsDataSource"
  [columnsToDisplay]="columnsToDisplay"
  [titleToDisplay]="titleToDisplay"
  [actions]="actions"
></app-customer-profile-grid>
